import { prepareDatetimeStringForAPI } from "shared/utils/dates";

import CustomInput from "./CustomInput";
import DateInput from "./DateInput";

export type DateValue = {
  id: string;
  name: string;
  value: string;
};

export type DateRangeInputProps = {
  id?: string;
  type?: "date" | "datetime-local";
  values: {
    from: DateValue;
    to: DateValue;
  };
  label?: string;
  onChangeDate: Function;
  isClearable?: boolean;
};

const DateRangeInput = (props: DateRangeInputProps) => {
  const { id, values, label, onChangeDate, isClearable, type = "date" } = props;

  const onRangeChange = (
    newStartDate: string | undefined,
    newEndDate: string | undefined
  ) => {
    onChangeDate({
      [values.from.id]:
        newStartDate === ""
          ? ""
          : type === "date"
          ? newStartDate || values.from.value
          : prepareDatetimeStringForAPI(newStartDate ?? values.from.value),
      [values.to.id]:
        newEndDate === ""
          ? ""
          : type === "date"
          ? newEndDate || values.to.value
          : prepareDatetimeStringForAPI(newEndDate ?? values.to.value),
    });
  };

  const onClearRange = () => {
    onChangeDate({
      [values.from.id]: "",
      [values.to.id]: "",
    });
  };

  return (
    <CustomInput
      id={id}
      label={label}
      onClear={
        isClearable && (values.from.value || values.to.value)
          ? onClearRange
          : undefined
      }
    >
      <div className="CustomInput__dateRange">
        <DateInput
          onChange={(e) => {
            onRangeChange(e.target.value, undefined);
          }}
          {...values.from}
          maxDate={values.to.value}
          type={type}
          placeholder="From"
          showPickerOnFocus
        />
        <DateInput
          onChange={(e) => {
            onRangeChange(undefined, e.target.value);
          }}
          {...values.to}
          minDate={values.from.value}
          type={type}
          placeholder="To"
          showPickerOnFocus
        />
      </div>
    </CustomInput>
  );
};

export default DateRangeInput;
